/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { groupInternalHighscorePath } from '../../components/GroupInternalHighscores';

interface GroupInternalHighscoreLinkProps extends React.PropsWithChildren{
    trId: string;
    ugId: number;
}

export class GroupInternalHighscoreLink extends React.PureComponent<GroupInternalHighscoreLinkProps> {

    render() {
        if (this.props.trId && this.props.ugId) {
            return (
                <Link to={groupInternalHighscorePath(String(this.props.trId), String(this.props.ugId))}>
                    {this.props.children}
                </Link>
            );
        } else {
            return (
                <div>{this.props.children}</div>
            );
        }
    }
}